module.exports = __webpack_public_path__ + "static/media/mary-jane-icon.2b7518e1.png";